import React from "react";
import { connect } from "react-redux";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { beatJson } from "../../../DynamicFormsJson/MastersJSON/beat";
import { getAreaByUserType } from "../../../Slice/area.slice";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { serverMsg, noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { withRouter } from "../../../components/withRouter";
import { compose } from "@reduxjs/toolkit";
import { getTownAll } from "../../../Slice/town.slice";
import { ButtonCompo } from "../../../components/Comman/Button";
import { Grid } from "@mui/material";
import endpoint from "../../../config/endpoints";

class BeatForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        areaForBeatDetail: this.props.areaForBeatList?.area,
        townDetail: this.props.town?.town,
      },
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.areaForBeatList !== nextProps.areaForBeatList) {
      if (
        this.props.areaForBeatList?.area !== nextProps.areaForBeatList?.area
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaForBeatDetail: nextProps.areaForBeatList?.area,
          },
        });
      }
    }
    if (this.props.town !== nextProps.town) {
      if (this.props.town?.town !== nextProps.town?.town) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            townDetail: nextProps.town?.town,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const { getAreaByUserType, getTownAll, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getAreaByUserType().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      if (
        localStorage.getItem("isShowTownInBeat") &&
        localStorage.getItem("isShowTownInBeat") == 1
      ) {
        showLoador({ loador: true });
        await getTownAll().then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  callBeforeSaveMethod = async (dataToSave, editData) => {
    if (
      Object.keys(editData).length == 0 ||
      (Object.keys(editData).length != 0 &&
        editData.beatName != dataToSave.beatName)
    ) {
      const { showLoador, showNotification } = this.props;
      if (navigator.onLine) {
        showLoador({ loador: true });
        const response = await apiGet({
          url:
            beatJson.apiBaseURL +
            "/beat-name-exist-or-not-by-area?areaId=" +
            dataToSave.area.id +
            "&beatName=" +
            dataToSave.beatName,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (!data.data.error) {
              showNotification({
                msg: data.data.message,
                severity: "error",
              });
            }
            return data.data.error;
          }
          return false;
        });
        return response;
      } else {
        showNotification({ msg: noInternetMsg, severity: "error" });
      }
    }
    return true;
  };

  onUpdateForAllNew = async (dataToSave) => {
    const { showNotification, showLoador } = this.props;

    if (navigator.onLine) {
      showLoador({ loador: true });
      const response = await apiGet({
        url:
          endpoint.assignBeat +
          "/update-beat-assign-distance-from-hq?beatId=" +
          dataToSave?.id +
          "&distanceFromHQ=" +
          dataToSave?.distanceFromHQ,
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (success) {
          if (data?.data?.statusCode == 500) {
            showNotification({
              msg: data?.data?.message,
              severity: "error",
            });

            return data?.data?.error;
          } else {
            showNotification({ msg: data?.data?.message, severity: "success" });
            this.props.navigate(-1);
            return data?.data?.error;
          }
        }

        return false;
      });
      return response;
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

    return true;
  };

  render() {
    const { dynamicMasterData } = this.state;

    const isShowTownInBeat = localStorage.getItem("isShowTownInBeat");

    const beatTypeNames = JSON.parse(localStorage.getItem("getBeatTypeNames"));

    const variable1 = beatTypeNames?.Type1 ?? "Working";
    const variable2 = beatTypeNames?.Type2 ?? "Non Working";

    let fieldMetaForBeatTypeTown = beatJson.fieldMetaForBeatTypeTown.map(
      (item) => {
        if (item.controlType === "radiogroup" && item.dataKey === "type") {
          return {
            ...item,
            radioGroupItems: item.radioGroupItems.map((radio) => {
              if (radio.value === "0") return { ...radio, label: variable1 };
              if (radio.value === "1") return { ...radio, label: variable2 };
              return radio;
            }),
          };
        }
        return item;
      }
    );

    let fieldMetaForBeatType = beatJson.fieldMetaForBeatType.map((item) => {
      if (item.controlType === "radiogroup" && item.dataKey === "type") {
        return {
          ...item,
          radioGroupItems: item.radioGroupItems.map((radio) => {
            if (radio.value === "0") return { ...radio, label: variable1 };
            if (radio.value === "1") return { ...radio, label: variable2 };
            return radio;
          }),
        };
      }
      return item;
    });

    return (
      <>
        <DynamicForm
          callBeforeSave={true}
          screenTitle={beatJson.screenTitle}
          fieldMeta={
            localStorage.getItem("showBeatTypeAndDistance") &&
            localStorage.getItem("showBeatTypeAndDistance") == 1 &&
            isShowTownInBeat == 0
              ? fieldMetaForBeatType
              : localStorage.getItem("showBeatTypeAndDistance") &&
                localStorage.getItem("showBeatTypeAndDistance") == 1 &&
                isShowTownInBeat == 1
              ? fieldMetaForBeatTypeTown
              : localStorage.getItem("showBeatTypeAndDistance") &&
                localStorage.getItem("showBeatTypeAndDistance") == 0 &&
                isShowTownInBeat == 0
              ? beatJson.fieldMeta
              : beatJson.fieldMetaForTown
          }
          callBeforeSaveMethod={this.callBeforeSaveMethod}
          formPath={beatJson.formPath}
          dynamicMasterData={dynamicMasterData}
          apiBaseURL={beatJson.apiBaseURL}
          showSaveNextBtn={beatJson.showSaveNextBtn}
          showUpdateToAll={this.onSave}
          isLog={true}
          type={0}
          showUpdateForAll={
            localStorage.getItem("isShowUpdateToAllButton") &&
            localStorage.getItem("isShowUpdateToAllButton") == 1
              ? true
              : false
          }
          onUpdateForAllNew={this.onUpdateForAllNew}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  areaForBeatList: state.area,
  town: state.town,
});
const mapDispatchToProps = {
  getAreaByUserType,
  getTownAll,
  showLoador,
  showNotification,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BeatForm);
